import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4f4e6f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "nav-center"
}
const _hoisted_3 = { class: "seg" }
const _hoisted_4 = { class: "nav-right" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "top-nav",
    style: _normalizeStyle({
      backgroundColor: `rgba(255,255,255,${$setup.bgAlpha-0.2})`,
     'backdrop-filter': $setup.bgAlpha > 0 ? 'blur(6px)' : 'none',
    '-webkit-backdrop-filter': $setup.bgAlpha > 0 ? 'blur(6px)' : 'none',
    })
  }, [
    _createCommentVNode(" 左：Logo "),
    _createElementVNode("div", {
      class: "nav-left",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-left')))
    }, [
      ($setup.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $setup.logo,
            alt: "logo",
            class: "logo"
          }, null, 8 /* PROPS */, _hoisted_1))
        : _renderSlot(_ctx.$slots, "left", { key: 1 }, undefined, true)
    ]),
    _createCommentVNode(" 中：双 Tab "),
    ($setup.props.homeTabs.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["seg-item", { active: $setup.activeIndex === 0 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onSelect(0))),
              style: _normalizeStyle($setup.btnStyle(0))
            }, _toDisplayString($setup.props.homeTabs[0].name), 7 /* TEXT, CLASS, STYLE */),
            _createElementVNode("button", {
              class: _normalizeClass(["seg-item", { active: $setup.activeIndex === 1 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSelect(1))),
              style: _normalizeStyle($setup.btnStyle(1))
            }, [
              _createTextVNode(_toDisplayString($setup.props.homeTabs[1].name), 1 /* TEXT */),
              _createCommentVNode(" 右侧小装饰圆点 "),
              _createCommentVNode(" <span class=\"dot\" v-if=\"activeIndex === 1\" /> ")
            ], 6 /* CLASS, STYLE */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 右：搜索按钮 "),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "icon-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('search')))
      }, [
        _createElementVNode("img", { src: $setup.searchIcon }, null, 8 /* PROPS */, _hoisted_5)
      ])
    ])
  ], 4 /* STYLE */))
}